import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { CreateEntry } from '../../providers/dataProvider'
import { isValidEmail, isValidPassword } from '../../utils/Validate'
import SaveSuccessModel from '../../components/common/SaveSuccessModel'

const ForgotPassword = () => {
    const navigate = useNavigate()

    // AFTER
    const prefillEmail = sessionStorage.getItem('resetEmail') || localStorage.getItem('resetEmail') || ''
    const prefillStep = parseInt(sessionStorage.getItem('resetStep') || '1')
    const [isMustReset] = useState(!!prefillEmail)

    const [step, setStep] = useState(prefillStep)
    const [userName, setUserName] = useState(prefillEmail)

    const [currentPassword, setCurrentPassword] = useState('')
    const [newPassword, setNewPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')

    const [showCurrent, setShowCurrent] = useState(false)
    const [showNew, setShowNew] = useState(false)
    const [showConfirm, setShowConfirm] = useState(false)

    const [loading, setLoading] = useState(false)
    const [errors, setErrors] = useState({})
    const [successShow, setSuccessShow] = useState(false)
    const [createMsg, setCreateMsg] = useState(null)

    // AFTER
    useEffect(() => {
        sessionStorage.removeItem('resetEmail')
        sessionStorage.removeItem('resetStep')
        localStorage.removeItem('resetEmail')
    }, [])

    useEffect(() => {
        if (successShow) {
            const timer = setTimeout(() => {
                navigate('/')
            }, 2000)
            return () => clearTimeout(timer)
        }
    }, [successShow])

    const SuccessDoneClick = () => {
        setSuccessShow(false)
        setCreateMsg(null)
        navigate('/')
    }

    const handleContinue = () => {
        if (!userName.trim()) return setErrors({ userName: 'Email is required' })
        if (!isValidEmail(userName)) return setErrors({ userName: 'Email address is invalid' })

        setErrors({})
        setStep(2)
    }

    const handleResetPassword = () => {
        const validationErrors = {}
        if (!currentPassword.trim()) validationErrors.currentPassword = 'Current (temporary) password is required'
        if (!newPassword.trim()) validationErrors.newPassword = 'New password is required'
        else if (!isValidPassword(newPassword)) validationErrors.newPassword = 'Password must be 8-20 characters and include uppercase, lowercase, number and special character (e.g. Test@1234)'
        if (!confirmPassword.trim()) validationErrors.confirmPassword = 'Confirm password is required'
        else if (newPassword !== confirmPassword) validationErrors.confirmPassword = 'Passwords do not match'

        if (Object.keys(validationErrors).length > 0) return setErrors(validationErrors)

        setErrors({})
        setLoading(true)

        CreateEntry('changepassword',
            { currentPassword, newPassword, confirmNewPassword: confirmPassword },
            (msg) => {
                setLoading(false)
                setCreateMsg(msg)
                if (msg?.status === 200) {
                    setSuccessShow(true)
                } else {
                    const errMsg = msg?.successData?.errors?.[0]?.message
                        || msg?.successData?.message
                        || 'Failed to reset password. Please try again.'
                    setErrors({ confirmPassword: errMsg })
                }
            },
            'success',
            'error'
        )
    }

    return (
        <>
            <style>{`
                .forgot-password-sec input[type="password"]::-ms-reveal,
                .forgot-password-sec input[type="password"]::-ms-clear,
                .create-new-password-sec input[type="password"]::-ms-reveal,
                .create-new-password-sec input[type="password"]::-ms-clear {
                    display: none;
                }
            `}</style>

            {step === 1 && (
                <section className="forgot-password-sec">
                    <div className="container-fluid">
                        <div className="row pt-5">
                            <div className="col-12">
                                <a href="/"><button type="button" className="btn back-btn">
                                    <i className="fas fa-angle-left mr-2"></i> Back
                                </button></a>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12"></div>
                            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12 my-auto">
                                <div className="row forgot-password_box">
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-header">
                                                <h3>{isMustReset ? 'Reset Password' : 'Forgot password'}</h3>
                                            </div>
                                            <div className="card-body">
                                                <div className="contact">
                                                    <div className="text-center">
                                                        <p>
                                                            {isMustReset
                                                                ? 'Your password must be changed. Please enter your email to continue.'
                                                                : 'Please enter your email address to continue'
                                                            }
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <label>Email address</label>
                                                        <input
                                                            type="email"
                                                            className="form-control mt-2"
                                                            placeholder="Enter email here"
                                                            value={userName}
                                                            onChange={(e) => { setUserName(e.target.value); setErrors({}) }}
                                                            onKeyDown={(e) => e.key === 'Enter' && handleContinue()}
                                                        />
                                                        {errors.userName && (
                                                            <div style={{ color: 'red' }}>{errors.userName}</div>
                                                        )}
                                                    </div>
                                                    <div className="mt-4">
                                                        <button
                                                            className="btn send-btn"
                                                            type="button"
                                                            onClick={handleContinue}
                                                            disabled={loading}>
                                                            Continue
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12"></div>
                        </div>
                    </div>
                </section>
            )}

            {step === 2 && (
                <section className="create-new-password-sec">
                    <div className="container-fluid">
                        <div className="row pt-5">
                            <div className="col-12">
                                <button type="button" className="btn back-btn"
                                    onClick={() => {
                                        setStep(1)
                                        setErrors({})
                                    }}>
                                    <i className="fas fa-angle-left mr-2"></i> Back
                                </button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12"></div>
                            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12 my-auto">
                                <div className="row create-new-password-box">
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-header">
                                                <h3>Reset Password</h3>
                                            </div>
                                            <div className="card-body">
                                                <div className="contact">
                                                    <div className="text-center mb-4">
                                                        <p>Enter the temporary password given by admin, <br /> then set your new password</p>
                                                    </div>

                                                    <div className="mb-3">
                                                        <label>Current (temporary) password</label>
                                                        <div className="input-group mt-2">
                                                            <input
                                                                type={showCurrent ? 'text' : 'password'}
                                                                className="form-control"
                                                                placeholder="Enter temporary password"
                                                                value={currentPassword}
                                                                onChange={(e) => { setCurrentPassword(e.target.value); setErrors({}) }}
                                                                autoComplete="current-password"
                                                            />
                                                            <div className="input-group-append">
                                                                <button type="button"
                                                                    className="btn btn-outline-secondary"
                                                                    onClick={() => setShowCurrent(!showCurrent)}
                                                                    tabIndex="-1">
                                                                    <i className={`fas ${showCurrent ? 'fa-eye' : 'fa-eye-slash'}`}></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        {errors.currentPassword && (
                                                            <div style={{ color: 'red', fontSize: '13px' }}>{errors.currentPassword}</div>
                                                        )}
                                                    </div>

                                                    <div className="mb-3">
                                                        <label>New password</label>
                                                        <div className="input-group mt-2">
                                                            <input
                                                                type={showNew ? 'text' : 'password'}
                                                                className="form-control"
                                                                placeholder="Enter new password here"
                                                                value={newPassword}
                                                                onChange={(e) => { setNewPassword(e.target.value); setErrors({}) }}
                                                                autoComplete="new-password"
                                                            />
                                                            <div className="input-group-append">
                                                                <button type="button"
                                                                    className="btn btn-outline-secondary"
                                                                    onClick={() => setShowNew(!showNew)}
                                                                    tabIndex="-1">
                                                                    <i className={`fas ${showNew ? 'fa-eye' : 'fa-eye-slash'}`}></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        {errors.newPassword && (
                                                            <div style={{ color: 'red', fontSize: '13px' }}>{errors.newPassword}</div>
                                                        )}
                                                    </div>

                                                    <div className="mb-3">
                                                        <label>Confirm password</label>
                                                        <div className="input-group mt-2">
                                                            <input
                                                                type={showConfirm ? 'text' : 'password'}
                                                                className="form-control"
                                                                placeholder="Confirm password here"
                                                                value={confirmPassword}
                                                                onChange={(e) => { setConfirmPassword(e.target.value); setErrors({}) }}
                                                                onKeyDown={(e) => e.key === 'Enter' && handleResetPassword()}
                                                                autoComplete="new-password"
                                                            />
                                                            <div className="input-group-append">
                                                                <button type="button"
                                                                    className="btn btn-outline-secondary"
                                                                    onClick={() => setShowConfirm(!showConfirm)}
                                                                    tabIndex="-1">
                                                                    <i className={`fas ${showConfirm ? 'fa-eye' : 'fa-eye-slash'}`}></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        {errors.confirmPassword && (
                                                            <div style={{ color: 'red', fontSize: '13px' }}>{errors.confirmPassword}</div>
                                                        )}
                                                    </div>

                                                    <div className="mt-4">
                                                        <button
                                                            className="btn update-password-btn"
                                                            type="button"
                                                            onClick={handleResetPassword}
                                                            disabled={loading}>
                                                            {loading ? 'Updating...' : 'Update password'}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12"></div>
                        </div>
                    </div>
                </section>
            )}

            <SaveSuccessModel
                show={successShow}
                createMsg={createMsg}
                setShow={setSuccessShow}
                SuccessDoneClick={SuccessDoneClick}
            />
        </>
    )
}

export default ForgotPassword